/*eslint-disable */
import { Dialog } from "@material-ui/core";
import React, { FunctionComponent, useEffect, useMemo } from "react";
import { formatNumber, purposeCodeList } from "../../utils";
import { IAmount } from "./Amount";
import Button from "../../components/ui/Button";
import { Mixpanel } from "../../constants/mixpanel";
import { useRecoilState } from "recoil";
import { panDeclaration, selectedPurpose } from "../../store";
import { CloseIcon } from "../../assets/Icons";
import RoundCloseIcon from "../../assets/Icons/RoundCloseIcon";

export const Modals: FunctionComponent<IAmount.ModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  receivingCountryModalData,
  setDestCurrency,
  // setPurposeCode,
  // setPurposeValue,
  setPan,
  setIsEducation,
  // sendTransferSummary,
  sendingAmount,
  destCurrency,
  errorMessage,
  isPurposeModalOpen,
  setIsPurposeModalOpen,
  isPanModelOpen,
  setIsPanModelOpen,
  tcs,
  setDeclareAmount,
  moneySendViaMoneyhop,
  enableDecalreAmount,
  modalLoading,
  setEnableDeclareAmount,
  setFirstTimeLoanPopup,
  firstTimeLoanPopup,
  declareAmount,
  setTcs
}) => {
  const [panDeclarationValue, setPanDeclarationValue] = useRecoilState(panDeclaration);
  const [, setPurposeCode] = useRecoilState(selectedPurpose)

  const handleClearInput = () => {
    setPanDeclarationValue("");
    setPan("")
  };

  useEffect(() => {
    const storedAmount = localStorage.getItem('declareAmount');
    if (storedAmount) {
      if (setDeclareAmount) {
        setDeclareAmount(storedAmount);
      }
    }
  }, []);

  useEffect(() => {
  if (panDeclarationValue.length !== 10 || !!errorMessage) {
    if (setDeclareAmount) {
    setDeclareAmount("");
    }
    localStorage.removeItem("declareAmount");
  }
}, [panDeclarationValue, errorMessage]);


  // Update localStorage whenever declareAmount changes
  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (panDeclarationValue.length === 10 && !errorMessage) {
      if (setDeclareAmount) {
      setDeclareAmount(value);
      }
      localStorage.setItem("declareAmount", value);
    }
  };



  const handleClearAmountInput = () => {
    if (setDeclareAmount) {
    setDeclareAmount(""); // Clear declareAmount
    }
    localStorage.removeItem('declareAmount'); // Remove from localStorage
  };



  const buttonTitle = useMemo(() => {
    return enableDecalreAmount ? "Submit" : "Proceed";
  }, [enableDecalreAmount]);

  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div>
      <Dialog open={isModalOpen === "recieve"} onClose={() => setIsModalOpen("")}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Destination Currency</div>
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryModalData && receivingCountryModalData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-9 lg:border-none lg:py-3 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setIsModalOpen("");
                    setDestCurrency(data.currencyName);
                    // sendTransferSummary && sendTransferSummary(sendingAmount, data.currencyName, true);
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.currencyName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    < div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>

      <Dialog open={isPurposeModalOpen} onClose={() => setIsPurposeModalOpen(false)}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Purpose Code</div>
        {purposeCodeList.map((el) => (
          <div
            key={el.code}
            onClick={() => {
              setPurposeCode({ purposeCode: el.code, purposeValue: el.value });
              setIsPurposeModalOpen(false);
              if (el.value === "Family Maintenance" || el.value === "Personal Gift or Donation") {
                // setFirstTimeLoanPopup(true);
                setIsEducation(false)
              } else {
                setIsModalOpen("loan");
                setFirstTimeLoanPopup(false);
              }
              // if (el.code === "S0305" && tcs !== 0) {
              //   // setIsModalOpen("loan");
              // } else {
              //   setIsEducation(false);
              // }
            }}
            className="px-3 py-2 mx-3 my-2 border rounded cursor-pointer hover:bg-gray-200"
          >
            {el.value}
          </div>
        ))}
      </Dialog>

      <Dialog open={isPanModelOpen} onClose={() => setIsPanModelOpen(false)}>
        <div className="border rounded-lg overflow-hidden">
          <div className="flex flex-row justify-end items-center px-8 py-3">
            <CloseIcon className="cursor-pointer" onClick={() => setIsPanModelOpen(false)} />
          </div>
          <div className="font-bold text-[22px] text-center text-black">Declaration</div>
          <div className="flex flex-col items-left px-10 w-[500px]">
            <span className="font-medium text-[24px] mt-5">PAN</span>
            <input
              className="px-6 py-2 w-full border border-gray-400 rounded-lg"
              type="text"
              value={panDeclarationValue}
              onChange={(e) => setPanDeclarationValue(e.target.value.toUpperCase())}
              autoComplete="off"
              pattern={specialCharRegExp}
              maxLength={10}
            />
            {panDeclarationValue && (
              <span
              className="relative bottom-5 left-96 -translate-y-1/2 cursor-pointer"
              onClick={handleClearInput}
              >
                <RoundCloseIcon />
              </span>
            )}
            {errorMessage && <span className="text-red-100 -mt-2 my-3">{errorMessage}</span>}
            {moneySendViaMoneyhop !== undefined  && panDeclarationValue.length === 10 && (
              <span className="font-normal relative bottom-6 text-justify text-[16px] mt-3">
                User has already done the transaction of worth ₹{formatNumber(moneySendViaMoneyhop)}
                .
              </span>
            )}
            {enableDecalreAmount && (
              <div className="flex flex-col relative bottom-6 items-left mt-6">
                <span className="font-semibold text-[24px] mt-6">Enter Amount</span>
                <span className="font-normal text-[16px]">
                  If you have done any other transaction please enter the amount in INR
                </span>
                <input
                  className="px-6 py-2 w-full my-4 border border-gray-400 rounded-lg"
                  type="number"
                  onChange={handleAmountChange}
                  autoComplete="off"
                  value={declareAmount}
                  disabled={panDeclarationValue.length !== 10 || !!errorMessage}
                />
              {panDeclarationValue.length === 10 && declareAmount ? (
                <span
                  className="relative bottom-[2.2rem] left-96 -translate-y-1/2 cursor-pointer"
                  onClick={handleClearAmountInput}
                >
                  <RoundCloseIcon />
                </span>
              ) : null}
              </div>
            )}
            <div className="flex flex-row pb-10 justify-center">
              <Button
                className={`px-6 py-3 mt-5 border rounded-lg w-[50%] text-white-100 ${!panDeclarationValue || panDeclarationValue.length !== 10 || errorMessage ||
                (typeof declareAmount === "string" && declareAmount === "") ||
                isNaN(Number(declareAmount)) ? "opacity-15": "opacity-100" }`}
                isLoading={modalLoading}
                onClickHandler={() => {
                  // sendTransferSummary(sendingAmount, destCurrency, false, false);
                  Mixpanel.track("PAN_based");
                    if (buttonTitle === "Submit" && !errorMessage) {
                      setIsPanModelOpen(false);
                      setEnableDeclareAmount(false);
                    }
                }}
              disabled={
                !panDeclarationValue || panDeclarationValue.length !== 10 ||
                (typeof declareAmount === "string" && declareAmount === "") ||
                isNaN(Number(declareAmount)) || errorMessage
              }
              >
                {buttonTitle}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
      {/*change in loan popup  */}
      <Dialog
        open={firstTimeLoanPopup === false && isModalOpen === "loan"}
        onClose={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10">
          <span className="font-semibold text-[24px] mt-6">
            If a loan has been taken for overseas education and the loan disbursement letter is
          </span>
          <span className="font-semibold text-[24px] mt-0">
            available, TCS will be charged at 0%. Is a loan disbursement letter available?
          </span>
          <span className="font-semibold text-[20px] mt-6">
            Note: You will be asked to upload a digital copy of the loan disbursement letter.
          </span>
          <div className="flex space-x-10">
            <button
              className="px-6 py-3 mt-5 border border-black rounded-lg"
              onClick={() => {
                setIsEducation(true);
                // setIsModalOpen("");
                setFirstTimeLoanPopup(true);
                setIsModalOpen("");
                setTcs(0)
              }}
            >
              Yes
            </button>
            <button
              className="px-6 py-3 mt-5 border border-black rounded-lg"
              onClick={() => {
                setIsEducation(false);
                setIsModalOpen("");
                setFirstTimeLoanPopup(true);
                // setIsModalOpen("");
              }}
            >
              No
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
